﻿import { LiveDataSetStation, LiveDataSetValue, Status } from "../API/LiveData/LiveDataSet";
import { DefaultParameterDefinitions } from "../DefaultParameterDefinitions";
import { MainSite } from "../MainSite";
import { GetWarningThreshold, WarningGroup } from "../Model/WarningGroup";
import { ParameterGroupInfo } from "../ParameterGroupInfoSet";
import { IStationValueFormatter, IStationValueObject } from "./IStationValueFormatter";

declare var sprintf;

export class LedStatusFormatter implements IStationValueFormatter {
    constructor(protected parameterGroup: ParameterGroupInfo, protected sensorId: string = null) {
    }

    public getShortName(): string {
        return this.parameterGroup.ShortName;
    }

    public getUnits(): string {
        return this.parameterGroup.Units;
    }

    public getParameterGroupInfo(): ParameterGroupInfo {
        return this.parameterGroup;
    }

    public getDescription(): string {
        return this.parameterGroup.Description;
    }

    public getId(): string {
        return this.parameterGroup.Id;
    }

    public getSensorId(): string | undefined {
        return undefined;
    }

    public plottable(): boolean {
        return false;
    }

    public axisMin(): number {
        return null;
    }

    public axisMax(): number {
        return null;
    }

    public plotLines(): boolean {
        return false;
    }

    protected getLiveDataSetValue(liveDataSetStation: LiveDataSetStation): LiveDataSetValue {
        var value: LiveDataSetValue = null;

        if (liveDataSetStation.GroupValues && this.parameterGroup.Id in liveDataSetStation.GroupValues) {
            if (this.sensorId) {
                if (!liveDataSetStation.GroupValues[this.parameterGroup.Id].some(_value => {
                    if (_value.Sensor == this.sensorId) {
                        value = _value;
                        return true;
                    }
                    return false;
                })) {
                    // a sensor id has been specified, but the group value is not present for this sensor
                    return null;
                }
            }
            else {
                value = liveDataSetStation.GroupValues[this.parameterGroup.Id][0];
            }
        }

        return value;
    }

    public format(liveDataSetStation: LiveDataSetStation, warningRules?: WarningGroup): IStationValueObject {
        // green = 0, red = 1, amber = 2, grey (default)

        // the default if parameter has never existed
        var valueObject: IStationValueObject = {
            Value: '---',
            Status: null,
            WarningThreshold: null,
            ParameterDefinition: null,
            Sensor: null,
            Timestamp: null
        }

        const value = this.getLiveDataSetValue(liveDataSetStation);
        if (value == null) {
            return valueObject;
        }

        var paramDef = MainSite.instance.staticDataManager.Schema.ParameterSchema.Stations[liveDataSetStation.Station.Id]
            .Sensors[value.Sensor]
            .Parameters[value.Parameter]
            .Variants[0]
            .ParameterDefinition;
        if ((!paramDef || paramDef.Default) && value.Parameter in DefaultParameterDefinitions.Parameters) {
            paramDef = DefaultParameterDefinitions.Parameters[value.Parameter];
        }

        // the default if parameter exists but has expired
        valueObject = {
            Value: '///',
            Status: value.ExpiryStatus,
            WarningThreshold: null,
            ParameterDefinition: paramDef,
            Timestamp: value.Timestamp,
            Sensor: value.Sensor
        }

        if (value.ExpiryStatus == Status.Expired) {
            return valueObject; // leave value as "///" if expired, don't bother checking warning rules
        }

        if (value.Value === null || value.Value === 'NIL') {
            // can be the case for cloud heights, etc
            valueObject.Value = '';

        } else if (typeof value.Value == 'number' && this.parameterGroup.Format) {

            valueObject.Value = sprintf(this.parameterGroup.Format, value.Value);

            if (warningRules) {
                valueObject.WarningThreshold = GetWarningThreshold(warningRules, value.Value, this.parameterGroup, liveDataSetStation);
            }

        } else {
            valueObject.Value = value.Value.toString();
        }

        return valueObject;
    }
}